// extracted by mini-css-extract-plugin
export default {"modal-content":"Module_modal-content__8PJct","modal-dialog":"Module_modal-dialog__KWxZB"};